module.exports = __webpack_public_path__ + "static/front-995434049ed692a3cac5b21656a9d4ac.png";